var exports = {
  "C": "moveRefusal__SDVL3A",
};

module.exports = exports;
